<template>

  <div class="form-group">

      <input 
        ref="filter"
        v-bind:id="filterId"
        class="form-control" />

  </div>
  
</template>

<script>

var moment = require('moment');

export default {
  name: "AppFilterDateRange",
  props: ['filterDateSingle', 'filterDateMin', 'filterDateMax', 'filterDateStartDefault', 'filterDateEndDefault', 'filterDateOverride'],
  components: {
  },
  data() {
    return {
      filterId: null,

      filterDateStart: null,
      filterDateEnd: null,

      filterDateRange: {
        'Today' : [moment(), moment()],
        'Yesterday' : [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days' : [moment().subtract(6, 'days'), moment()],
        'Last 30 Days' : [moment().subtract(29, 'days'), moment()],
        'This Month' : [moment().startOf('month'), moment().endOf('month')],
        'Last Month' : [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      }
    };
  },
  mounted() {
    this.filterId = "jt_filter_" + this._uid;

    this.filterDateStart = moment().startOf('day');
    this.filterDateEnd = moment().endOf('day');

    let option = {
      singleDatePicker: this.filterDateSingle,
      startDate : this.filterDateStart,
      endDate : this.filterDateEnd,
      ranges : this.filterDateRange,
    }

    if(this.filterDateMin) {
      option['minDate'] = moment.unix(this.filterDateMin).toDate()
    }

    if(this.filterDateMax) {
      option['maxDate'] = moment.unix(this.filterDateMax).toDate()
    }

    this.$nextTick(() => {
      let self = this;
      $('#' + this.filterId).daterangepicker(option, function(start, end, label) {
        self.filterDateStart = moment(start);
        self.filterDateEnd = moment(end);
        self.onFilterDataChange(start, end);
      });
    })
  },
  methods: {
    setStartDate(startDate) {
      this.filterDateStart = startDate
      $('#' + this.filterId).data('daterangepicker').setStartDate(startDate.toDate());
    },
    setEndDate(endDate) {
      this.filterDateEnd = endDate
      $('#' + this.filterId).data('daterangepicker').setEndDate(endDate.toDate());
    },
    onFilterDataChange(start, end) {
      if(this.filterDateOverride && typeof this.filterDateOverride === "function") {
        this.filterDateOverride(this, start, end)
        return;
      }
      this.$emit('filter-data-change', start, end);
    },
  },
};

</script>


// WEBPACK FOOTER //
// src/components/App/AppFilterDateRange.vue